<template>
  <div class="Swiperslidecard">
    <!-- <div class="bcpoint">
      <div class="smallpoint" v-for="n in 200"></div>
    </div> -->
    <div class="content-container">
      <div class="swipercon">
        <!-- swiper -->

        <div
          slot="button-prev"
          class="swiper-button-prev"
        >
          <a-icon type="left" />
        </div>
        <div
          slot="button-next"
          class="swiper-button-next"
        >
          <a-icon type="right" />
        </div>

        <swiper :options="swiperOption">
          <swiper-slide
            v-for="(item, index) in list"
            :key="index"
          >
            <div>
              <div class="circle">
                {{ item.time }}
              </div>
              <div class="ctxt">
                {{ item.title }}
              </div>
            </div>
          </swiper-slide>
          <!-- <swiper-slide>
            <div class="circlebig">
              <div class="circle circleend">
                即将到来
              </div>
              <div class="ctxt ctxtend">主网完全启动</div>
            </div>
          </swiper-slide> -->
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
// import SectionCard from "@/components/SectionCard.vue";

export default {
  components: {
    // SectionCard
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 10,
        // centeredSlides: true,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 640px
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1040: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }
      }
    };
  },
  computed: {
    list () {
      const value = [
        {
          time: "2017.12",
          title: this.$t("home.s6.list.l1")
        },
        {
          time: "2018.06",
          title: this.$t("home.s6.list.l2")
        },
        {
          time: "2018.08",
          title: this.$t("home.s6.list.l3")
        },
        {
          time: "2018.09",
          title: this.$t("home.s6.list.l4")
        },
        {
          time: "2018.11",
          title: this.$t("home.s6.list.l5")
        },
        {
          time: "2019.03",
          title: this.$t("home.s6.list.l6")
        },
        {
          time: "2019.09",
          title: this.$t("home.s6.list.l7")
        },
        {
          time: "2019.11",
          title: this.$t("home.s6.list.l8")
        },
        {
          time: "2020 Q1-Q2",
          title: this.$t("home.s6.list.l9")
        },
        {
          time: "2020 Q3-Q4",
          title: this.$t("home.s6.list.l10")
        },
        {
          time: "2021 Q1-Q2",
          title: this.$t("home.s6.list.l11")
        },
        {
          time: "2021 Q3-Q4",
          title: this.$t("home.s6.list.l12")
        },
        {
          time: "2022 Q1",
          title: this.$t("home.s6.list.l13")
        },
        {
          time: "2022 Q2",
          title: this.$t("home.s6.list.l14")
        },
        {
          time: "2022 Q3",
          title: this.$t("home.s6.list.l15")
        },
        {
          time: "2022 Q4",
          title: this.$t("home.s6.list.l16")
        },
        {
          time: "2023 Q1",
          title: this.$t("home.s6.list.l17")
        },
        {
          time: "2023 Q2",
          title: this.$t("home.s6.list.l18")
        },
        {
          time: "2023 Q3",
          title: this.$t("home.s6.list.l19")
        },
        {
          time: "2023 Q4",
          title: this.$t("home.s6.list.l20")
        },
        {
          time: "2024 Q1",
          title: this.$t("home.s6.list.l21")
        }
      ];
      return value;
    }
  }
};
</script>

<style lang="less" scoped>
@media (max-width: 500px) {
  .Swiperslidecard {
    position: relative;
  }
  .swiper-slide {
    width: 180px;

    margin-top: 46px;
  }

  .swipercon {
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    position: relative;
  }
  .swiper-container {
    width: 70%;
    position: relative;
  }

  .circle {
    margin: 0 auto;
    width: 70px;
    height: 70px;
    background: rgba(63, 74, 225, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    border-radius: 45px;
    line-height: 70px;
    text-align: center;

    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    margin-bottom: 33px;
  }
  .circleend {
    background: rgba(66, 198, 172, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    margin-left: 18px;
  }
  .ctxtend {
    position: relative;
  }

  .circlebig {
    width: 108px;
    height: 108px;
    background: rgba(66, 198, 172, 0.14);

    border-radius: 54px;
    line-height: 90px;
    text-align: center;

    font-size: 16px;
    margin-bottom: 33px;
    padding-top: 18px;
    margin-top: -18px;
  }

  .ctxt {
    font-size: 14px;

    color: rgba(38, 38, 38, 1);
    line-height: 25px;
    text-align: center;
  }
  .swiper-button-prev {
    left: 2%;
    top: 43%;
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    border-radius: 19px;
    text-align: center;
    line-height: 38px;
  }
  .swiper-button-next {
    right: 2%;
    top: 43%;
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    border-radius: 19px;
    text-align: center;
    line-height: 38px;
  }

  .bcpoint {
    height: 10px;
    position: absolute;
    width: 100%;
    top: 39%;
    height: 10px;
    overflow: hidden;
    line-height: 10px;
  }

  .smallpoint {
    width: 10px;
    height: 10px;
    background: linear-gradient(
      270deg,
      rgba(71, 103, 245, 1) 0%,
      rgba(76, 85, 242, 1) 100%
    );
    opacity: 0.14;
    border-radius: 5px;
    display: inline-block;
    margin-right: 21px;
  }
}

@media (min-width: 501px) {
  .Swiperslidecard {
    position: relative;
  }
  .swiper-slide {
    width: 180px;

    margin-top: 26px;
  }

  .swipercon {
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 87%;
    position: relative;
  }
  .swiper-container {
    width: 70%;
    position: relative;
  }

  .circle {
    margin: 0 auto;
    width: 90px;
    height: 90px;
    background: rgba(63, 74, 225, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    border-radius: 45px;
    line-height: 90px;
    text-align: center;

    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    margin-bottom: 33px;
  }
  .circleend {
    background: rgba(66, 198, 172, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    margin-left: 26px;
  }
  .ctxtend {
    position: relative;
  }

  .circlebig {
    width: 142px;
    height: 142px;
    background: rgba(66, 198, 172, 0.14);

    border-radius: 71px;
    line-height: 90px;
    text-align: center;

    font-size: 20px;
    margin-bottom: 33px;
    padding-top: 26px;
    margin-top: -26px;
  }

  .ctxt {
    font-size: 14px;

    color: rgba(38, 38, 38, 1);
    line-height: 25px;
    text-align: center;
  }
  .swiper-button-prev {
    left: 2%;
    top: 43%;
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    border-radius: 19px;
    text-align: center;
    line-height: 38px;
  }
  .swiper-button-next {
    right: 2%;
    top: 43%;
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 7px 0px rgba(170, 188, 255, 1);
    border-radius: 19px;
    text-align: center;
    line-height: 38px;
  }

  .bcpoint {
    height: 10px;
    position: absolute;
    width: 100%;
    top: 37%;
    height: 10px;
    overflow: hidden;
    line-height: 10px;
  }

  .smallpoint {
    width: 10px;
    height: 10px;
    background: linear-gradient(
      270deg,
      rgba(71, 103, 245, 1) 0%,
      rgba(76, 85, 242, 1) 100%
    );
    opacity: 0.14;
    border-radius: 5px;
    display: inline-block;
    margin-right: 21px;
  }
}
</style>
